import { Box, CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material'
import { Provider, useSelector } from 'react-redux'
import { store, type RootState } from './store'
import { router, routerAdmin } from './routes'
import { TenantBootstrap } from './components/tenant-bootstrap'
import { RouterProvider } from 'react-router-dom'
import { criarTemaApp } from './theme'
import { useMemo } from 'react'

export default function App(): JSX.Element {
  return (
    <Provider store={store}>
      <AppComTema />
    </Provider>
  )
}

function AppComTema(): JSX.Element {
  const mode = useSelector((s: RootState) => s.tema.mode)
  const tema = useMemo(() => criarTemaApp(mode), [mode])
  const ehAdmin = window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/totem')

  return (
    <ThemeProvider theme={tema}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          '::view-transition-old(root), ::view-transition-new(root)': {
            animationDuration: '280ms',
            animationTimingFunction: 'ease',
          },
        }}
      />
      {ehAdmin ? (
        <RouterProvider router={routerAdmin} />
      ) : (
        <Box
          sx={{
            // `dvh` (viewport dinâmica) e não `vh`: no Safari do iPad/iPhone o
            // `100vh` é a viewport GRANDE, como se a barra do navegador
            // estivesse escondida. A casca ficava mais alta que a área visível e
            // a página rolava sozinha a altura da barra — no tablet de mesa, que
            // é tela cheia, isso aparecia como rolagem em algo que não rola.
            minHeight: '100vh',
            '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
            bgcolor: 'background.paper',
          }}
        >
          <TenantBootstrap>
            <RouterProvider router={router} />
          </TenantBootstrap>
        </Box>
      )}
    </ThemeProvider>
  )
}
